









































import { Component, Vue } from "vue-property-decorator";
import SpanishText from "@/components/SpanishText.vue"; // @ is an alias to /src
import global from "@/ts/Global";
import { EntryValue, EntriesMap } from "@/ts/Types";
import FlashCard from "@/ts/FlashCard";
const SORTOPTIONS = ["Hardest"];
@Component({
  components: {
    SpanishText
  }
})
export default class CardStats extends Vue {
  // public raw: EnteriesMap | null = user.data;
  public selection: string = "Sort By";
  public collectionSelection: string | null = null;
  public myGlobal = global;
  public myCards: FlashCard[] = [];
  get collectionNames(): string[] | null {
    return this.myGlobal.collectionNames;
  }
  mounted() {
    (window as any).stats = this;
  }
  async collectionSelected() {
    if (!this.collectionSelection) return;
    this.myCards = await this.myGlobal.getFlashCards(this.collectionSelection);
    console.table(this.myCards.map(x => [x.key, x.value]));
  }
  sortByHardest(): FlashCard[] {
    // if (this.myCards.length < 1) this.myCards = [...user.flashCards];
    console.log("# flashcard:", this.myCards.length);

    this.selection = "hardest";
    return this.myCards.sort(
      (a: FlashCard, b: FlashCard) => a.successRate - b.successRate
    );
  }
  setFlashCards() {}
}
